import css from './tag.module.css'
import { ReactComponent as CloseIcon } from 'assets/icons/IconClose.svg'

interface IProps {
  onDelete?: () => void
  label: string
  theme?: 'primary' | 'secondary'
}

const Tag = (props: IProps) => {
  const handleOnClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (props.onDelete) props.onDelete()
  }

  return (
    <div className={`${css.tag} ${props.theme ? css[props.theme] : ''}`}>
      <span className='text--body-s'>{props.label}</span>
      {props.onDelete && <CloseIcon className={'delete-icon'} onClick={handleOnClick} />}
    </div>
  )
}

export default Tag
